// Constantes base para rutas
const COMMUNICATION_BASE = '/communication';
const REPORTS_BASE = '/report';
const OBSERVATORY_BASE = '/observatory';
const MONITOR_BASE = '/monitor';
const MAP_BASE = '/map';
export const ROUTES = {
  PUBLIC: {
    ROOT: '/',
    LOGIN: '/login',
    CALLBACK: '/callback',
  },
  
  MAIN: {
    HOME: '/home',
    USERS: '/users',
    USER_PROFILES: '/users/profiles',
    PROFILE: '/profile',
    MONITOR: '/monitor',
    NOTIFICATIONS: '/notifications',
    MAP: '/map',
  },
  MAP: {
    ROOT: MAP_BASE,
    THRESHOLD: `${MAP_BASE}/threshold-settings`,
    MONITOR: `${MAP_BASE}/monitor-center`,
    EDIT_THRESHOLD: {
      STORM: `${MAP_BASE}/threshold-settings/storm`,
      WIND: `${MAP_BASE}/threshold-settings/wind`,
      FLOOD: `${MAP_BASE}/threshold-settings/flood`,
      FROST: `${MAP_BASE}/threshold-settings/frost`,
      HIGH_TEMPERATURES: `${MAP_BASE}/threshold-settings/high-temperatures`,
      LOW_TEMPERATURES: `${MAP_BASE}/threshold-settings/low-temperatures`,
    },
  },
  
  MONITOR: {
    PLUVIAL: `${MONITOR_BASE}/pluvial-risk-map`,
    THRESHOLD: `${MONITOR_BASE}/pluvial-risk-map/threshold-settings`,
    EDIT_THRESHOLD: {
      STORM: `${MONITOR_BASE}/pluvial-risk-map/threshold-settings/storm`,
      WIND: `${MONITOR_BASE}/pluvial-risk-map/threshold-settings/wind`,
      FLOOD: `${MONITOR_BASE}/pluvial-risk-map/threshold-settings/flood`,
      FROST: `${MONITOR_BASE}/pluvial-risk-map/threshold-settings/frost`,
      HIGH_TEMPERATURES: `${MONITOR_BASE}/pluvial-risk-map/threshold-settings/high-temperatures`,
      LOW_TEMPERATURES: `${MONITOR_BASE}/pluvial-risk-map/threshold-settings/low-temperatures`,
    },
  },
  
  COMMUNICATION: {
    ROOT: COMMUNICATION_BASE,
    LIST_ALERTS: `${COMMUNICATION_BASE}/list-alerts`,
    LIST_ALERTS_PHENOMENON: `${COMMUNICATION_BASE}/list-alerts-phenomenon`,
    LIST_ALERTS_PHENOMENON_BY_TYPE: `${COMMUNICATION_BASE}/list-alerts-phenomenon/:phenomenonType`,
    LIST_ALERTS_INFO: `${COMMUNICATION_BASE}/list-alerts-info`,
    LIST_ALERTS_INFO_BY_TYPE: `${COMMUNICATION_BASE}/list-alerts-info/:phenomenonType`,
    LIST_ALERTS_PRONOSTICS: `${COMMUNICATION_BASE}/list-alerts-pronostics`,
    LIST_ALERTS_PRONOSTICS_BY_TYPE: `${COMMUNICATION_BASE}/list-alerts-pronostics/:phenomenonType`,
    LIST_ALERTS_NEWS: `${COMMUNICATION_BASE}/list-alerts-news`,
    LIST_ALERTS_NEWS_BY_TYPE: `${COMMUNICATION_BASE}/list-alerts-news/:phenomenonType`,
    CREATE_FORECAST: `${COMMUNICATION_BASE}/create-forecast`,
    CREATE_MULTIPLE_FORECAST: `${COMMUNICATION_BASE}/create-multiple-forecast`,
    INFO: `${COMMUNICATION_BASE}/info`,
    INFO_TYPES: {
      GENERAL: `${COMMUNICATION_BASE}/info/info`,
      TRAFFIC: `${COMMUNICATION_BASE}/info/traffic`,
      SECURITY: `${COMMUNICATION_BASE}/info/security`,
      WILDLIFE: `${COMMUNICATION_BASE}/info/wildlife`,
    },
    NEWS: `${COMMUNICATION_BASE}/news`,
    PHENOMENON: `${COMMUNICATION_BASE}/phenomenon`,
    // Subrutas de fenómenos
    PHENOMENON_TYPES: {
      FLOOD: `${COMMUNICATION_BASE}/phenomenon/flood`,
      STORM: `${COMMUNICATION_BASE}/phenomenon/storm`,
      WIND: `${COMMUNICATION_BASE}/phenomenon/wind`,
      DRILL: `${COMMUNICATION_BASE}/phenomenon/drill`,
      FROST: `${COMMUNICATION_BASE}/phenomenon/frost`,
      TROPICAL_CYCLONE: `${COMMUNICATION_BASE}/phenomenon/tropical-cyclone`,
      FOREST_FIRE: `${COMMUNICATION_BASE}/phenomenon/forest-fire`,
      VOLCANIC: `${COMMUNICATION_BASE}/phenomenon/volcanic`,
      LOW_TEMPERATURES: `${COMMUNICATION_BASE}/phenomenon/low-temperatures`,
      HIGH_TEMPERATURES: `${COMMUNICATION_BASE}/phenomenon/high-temperatures`,
      EARTHQUAKE: `${COMMUNICATION_BASE}/phenomenon/earthquake`,
      TSUNAMI: `${COMMUNICATION_BASE}/phenomenon/tsunami`,
      ENVIRONMENTAL_RISK: `${COMMUNICATION_BASE}/phenomenon/environmental_risk`,
      SILENT: `${COMMUNICATION_BASE}/phenomenon/silent`,
      HAIL: `${COMMUNICATION_BASE}/phenomenon/hail`,
      DUST_DEVIL: `${COMMUNICATION_BASE}/phenomenon/dust-devil`,
      FOG: `${COMMUNICATION_BASE}/phenomenon/fog`,
      WAVES: `${COMMUNICATION_BASE}/phenomenon/waves`,
      SWELL: `${COMMUNICATION_BASE}/phenomenon/swell`,
    },
    
    // Subrutas de detalles de alertas
    ALERT_DETAILS: {
      PHENOMENON: `${COMMUNICATION_BASE}/list-alerts-phenomenon/:phenomenonType/:id`,
      INFO: `${COMMUNICATION_BASE}/list-alerts-info/:phenomenonType/:id`,
      PRONOSTICS: `${COMMUNICATION_BASE}/list-alerts-pronostics/:phenomenonType/:id`,
      NEWS: `${COMMUNICATION_BASE}/list-alerts-news/:phenomenonType/:id`,
    },
  },
  
  REPORTS: {
    ROOT: REPORTS_BASE,
    EDL: `${REPORTS_BASE}/edl`,
    ANALYTICS: `${REPORTS_BASE}/analytics`,
    APP_ANALYTICS: `${REPORTS_BASE}/app-analytics`,
    DEMOGRAPHIC_GRAPHS: `${REPORTS_BASE}/demographic-graphs`,
  },
  
  OBSERVATORY: {
    ROOT: OBSERVATORY_BASE,
    CONDICIONES_METEOROLOGICAS: `${OBSERVATORY_BASE}/condiciones-meteorologicas`,
    EVENTOS_TORMENTA: `${OBSERVATORY_BASE}/eventos-tormenta`,
    MONITOREO_AMBIENTAL: `${OBSERVATORY_BASE}/monitoreo-ambiental`,
    MONITOREO_VOLCANICO: `${OBSERVATORY_BASE}/monitoreo-volcanico`,
    MAPA_INTERACTIVO: `${OBSERVATORY_BASE}/mapa-interactivo`,
    MONITOREO_SISMICO: `${OBSERVATORY_BASE}/monitoreo-sismico`,
    CONFIGURACION_SENSORES_SISMICOS: `${OBSERVATORY_BASE}/monitoreo-sismico/configuracion-sensores`,
  },
} as const;

// Tipos para TypeScript
export type RouteKeys = keyof typeof ROUTES;
export type CommunicationRoutes = typeof ROUTES.COMMUNICATION;
export type PhenomenonRoutes = typeof ROUTES.COMMUNICATION.PHENOMENON_TYPES;
export type AlertDetailsRoutes = typeof ROUTES.COMMUNICATION.ALERT_DETAILS;
